<template>
  <div class="error-page">
    <div class="error-message text-center px-4 my-8">
      <h1>404</h1>
      <h2>We didn't find anything here.</h2>
      <a class="link-underline" title="Go to tagboard.com" href="https://tagboard.com">Go to tagboard.com</a>
    </div>
  </div>
</template>

<script>
export default {};
</script>
